import React from "react";

export const ChoicePlanContext = React.createContext({
    parentState: null,
});